import { createSelector } from 'reselect';

import { IWizard, IWizardStep, WizardStepsCn } from './index';
import { RootState } from '../index';

export const wizardSelector = (state: RootState) => state.wizard;

export const wizardStepsCountSelector = createSelector(
  wizardSelector,
  (wizard: IWizard): number => wizard.steps.length,
);

export const activeStepCnSelector = createSelector(
  wizardSelector,
  (wizard: IWizard): WizardStepsCn => wizard.activeStep,
);

export const activeStepSelector = createSelector(
  wizardSelector,
  (wizard: IWizard): IWizardStep =>
    wizard.steps.find((step) => step.canonicalName === wizard.activeStep),
);

export const activeStepIndexSelector = createSelector(
  wizardSelector,
  (wizard: IWizard): number =>
    wizard.steps.findIndex((step) => step.canonicalName === wizard.activeStep),
);

export const wizardStepsSelector = createSelector(
  wizardSelector,
  (wizard: IWizard): IWizardStep[] => wizard.steps,
);

export const wizardAvailableStepsSelector = createSelector(
  wizardSelector,
  (wizard: IWizard): IWizardStep[] =>
    wizard.steps.filter((x) => x.isAvailable).sort((a, b) => a.order - b.order),
);

export const wizardSortedStepsSelector = createSelector(
  wizardSelector,
  (wizard: IWizard): IWizardStep[] =>
    wizard.steps.filter((x) => x).sort((a, b) => a.order - b.order),
);

export const wizardVisibleStepIndexSelector = createSelector(
  activeStepCnSelector,
  wizardAvailableStepsSelector,
  (activeStepCn: string, visibleSteps: IWizardStep[]): number =>
    visibleSteps.findIndex((step) => step.canonicalName === activeStepCn),
);

export const lastVisibleStepSelector = createSelector(
  wizardAvailableStepsSelector,
  (visibleSteps: IWizardStep[]): IWizardStep =>
    visibleSteps[visibleSteps.length - 1],
);

export const lastVisibleStepIndexSelector = createSelector(
  wizardStepsSelector,
  lastVisibleStepSelector,
  (steps: IWizardStep[], lastVisibleStep: IWizardStep): number =>
    steps.lastIndexOf(lastVisibleStep),
);

export const activeStepCaptionSelector = createSelector(
  wizardStepsSelector,
  activeStepIndexSelector,
  (wizardSteps: IWizardStep[], activeStep: number): string =>
    wizardSteps[activeStep].caption,
);

export const activeStepUrlSelector = createSelector(
  wizardStepsSelector,
  activeStepIndexSelector,
  (wizardSteps: IWizardStep[], activeStep: number): string =>
    wizardSteps[activeStep].url,
);
